import {
  IToggleStyleProps,
  IToggleStyles,
  Toggle,
  TooltipHost,
} from '@fluentui/react';
import React from 'react';
import { FilterArrayType, FilterCombineType, FilterProps } from '.';

export type ToggleFilterProps = FilterProps & {
  placeholder?: string;
  inlineLabel?: boolean;
  onOptionChange?: (data: FilterArrayType) => void;
  disabled?: boolean;
  defaultFilter?: boolean;
  controlled?: boolean;
  combineType?: FilterCombineType;
};

export const ToggleFilter: React.FC<ToggleFilterProps> = ({
  placeholder = 'Select item',
  defaultFilter = false,
  onOptionChange,
  filterKey,
  disabled = false,
  controlled = false,
  combineType = FilterCombineType.AND,
  inlineLabel,
  ...props
}) => {
  const label = defaultFilter ? placeholder : undefined;
  const tooltipContent = defaultFilter ? undefined : placeholder;

  return (
    <TooltipHost content={tooltipContent}>
      <Toggle
        disabled={disabled}
        styles={getToggleStyles}
        label={placeholder}
        inlineLabel={inlineLabel}
        onChange={(_, value) => {
          onOptionChange?.({
            value: !!value,
            filterKey,
            label: label ?? '',
            combineType,
          });
        }}
        {...props}
      />
    </TooltipHost>
  );
};
function getToggleStyles(props: IToggleStyleProps): Partial<IToggleStyles> {
  return {
    root: {
      textAlign: 'center',
      border: 0,
      padding: '5px 10px 0px 0px',
      selectors: {
        ':hover': {
          borderRadius: 5,
          backgroundColor: props.theme?.palette.neutralLight,
        },
      },
    },
  };
}
